import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "head" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  class: "textarea-block"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tabs = _resolveComponent("Tabs")
  const _component_TextArea = _resolveComponent("TextArea")
  const _component_BuilderInputs = _resolveComponent("BuilderInputs")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    onClickOutside: $options.close
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createTextVNode(" Add Sample ")),
        _createVNode(_component_Icon, {
          class: "pointer",
          disabled: $data.loading,
          icon: "x-close",
          stroke: "var(--gray-400)",
          height: "2rem",
          width: "2rem",
          onClick: $options.close
        }, null, 8 /* PROPS */, ["disabled", "onClick"])
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Tabs, {
          modelValue: $data.active_tab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.active_tab) = $event)),
          tabs: ['vars', 'json'],
          bordered: ""
        }, null, 8 /* PROPS */, ["modelValue"]),
        ($data.active_tab === 'json')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_TextArea, {
                modelValue: $data.text,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.text) = $event)),
                "vread-from": "valid",
                "onUpdate:valid": $event => (($data.valid) = $event),
                type: "textarea-json",
                rows: 15,
                maxlength: 20480,
                error: _ctx.error,
                required: ""
              }, null, 8 /* PROPS */, ["modelValue", "onUpdate:valid", "error"])
            ]))
          : ($data.active_tab === 'vars')
            ? (_openBlock(), _createBlock(_component_ScrollBar, {
                key: 1,
                class: "vars"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_BuilderInputs, {
                    "vread-from": "valid",
                    "onUpdate:valid": $event => (($data.valid) = $event),
                    opts: $data.schema,
                    gap: "1rem",
                    propstore: $data.fields
                  }, null, 8 /* PROPS */, ["onUpdate:valid", "opts", "propstore"])
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
      ])
    ]),
    controls: _withCtx(() => [
      _createVNode(_component_Button, {
        primary: "",
        disabled: !$data.valid,
        loading: $data.loading,
        onClick: _cache[2] || (_cache[2] = $event => ($options.saveSample()))
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode(" Save ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "loading"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onClickOutside"]))
}